enum TipoFiltroBuscaEleitoresTecnicoEnum {
  LOTACAO,
  PERSONALIZADO,
}

export default TipoFiltroBuscaEleitoresTecnicoEnum;
